<div class="bg-white background"></div>
<app-menu-template2>
  <main class="container-fluid">
    <header class="row bg-header">
      <div class="col-2 m-auto">
        <img
          class="col-sm-12 p-0 mt-4 ml-3"
          src="../../../../../assets/images/faq.png"
        />
      </div>
      <div class="col-10 m-auto">
        <p class="m-0 ml-4">Registro Nacional de Turismo</p>
        <h1 class="m-0 font-weight-bold ml-4">Preguntas frecuentes</h1>
      </div>
    </header>
    <app-menu-template4 [faq]="faq" (clickCollapse)="onCollase($event)">
      <div
        class="col-12 border-bottom mb-3"
        *ngFor="let item of faq; let num = index"
      >
        <header>
          <a
            class="text-primary d-flex"
            (click)="onCollase(item)"
            [attr.aria-expanded]="!item.isCollapse"
            [attr.aria-controls]="'pregunta_' + num"
          >
            <h5 *ngIf="item.isCollapse" class="font-weight-bold pointer">+</h5>
            <h5 *ngIf="!item.isCollapse" class="font-weight-bold pointer">-</h5>
            <h5 class="ml-2 pointer">
              {{
                item.faq_seccion_descripcion.charAt(0).toUpperCase() +
                  item.faq_seccion_descripcion.slice(1).toLowerCase()
              }}
            </h5>
          </a>
          <ng-container *ngFor="let itemP of item.preguntas">
            <p
              class="text-muted"
              *ngIf="item.isCollapse"
              [innerHTML]="itemP.pregunta"
            ></p>
          </ng-container>
        </header>
        <aside [id]="'pregunta_' + num" [ngbCollapse]="item.isCollapse">
          <div class="card border-0 p-0">
            <div class="card-body p-0">
              <ng-container *ngFor="let itemP of item.preguntas">
                <p
                  class="text-muted"
                  *ngIf="!item.isCollapse"
                  [innerHTML]="itemP.pregunta"
                ></p>
                <ul>
                  <li class="list-unstyled" [innerHTML]="itemP.respuesta"></li>
                </ul>
              </ng-container>
            </div>
          </div>
        </aside>
      </div>
    </app-menu-template4>
  </main>
</app-menu-template2>
